export default function getResource(label, vars = []) {
    const resources = {
        codesExhaustedHeading: 'Tous les codes promotionnels disponibles ont été réclamés.',
        codesExhaustedBody: 'Mais puisque vous êtes ici, profitez d’autres offres de Sephora.',
        shopNow: 'Magasiner',
        promotionEndedHeading: 'Cette offre est terminée.',
        promotionEndedBody: 'Mais puisque vous êtes ici, profitez d’autres offres de Sephora.',
        alreadyRegisteredHeading: `Vous vous êtes déjà inscrit(e) pour recevoir votre réduction de ${vars[0]}!`,
        alreadyRegisteredBody: 'Consultez votre boîte de réception pour plus de détails.',
        selfRegistrationHeading: 'Oops, you can\'t redeem your own link.',
        selfRegistrationBody: 'Share it with a friend, or shop other offers below.'
    };

    return resources[label];
}
